export const getMaybeRefValue = <T>(maybeRef: MaybeRef<T>): T =>
  maybeRef && isRef(maybeRef) ? maybeRef.value : maybeRef
